<template>
  <div>

    <div class="container">
      <div style="margin-bottom: 20px; margin-right: 20px; " size="medium">

        <el-radio-group v-model="radioType" style="margin-right: 20px; " size="medium">
          <el-radio-button label="pad">pad</el-radio-button>
          <el-radio-button label="app">app</el-radio-button>
          <el-radio-button label="all">all</el-radio-button>
          <el-radio-button label="xbike">xbike</el-radio-button>
          <el-radio-button label="litbike">litbike</el-radio-button>
          <el-radio-button label="boombike">boombike</el-radio-button>
          <el-radio-button label="boombasic">boombasic</el-radio-button>
          <el-radio-button label="ebike">ebike</el-radio-button>
        </el-radio-group>
      </div>
      <!-- 日期区间选择器 -->
      <el-date-picker v-model="range" type="monthrange" unlink-panels range-separator="至" start-placeholder="开始月份"
        end-placeholder="结束月份" :picker-options="pickerOptions">
      </el-date-picker>
      <div style=" margin-right: 80px; "> </div>
      <div style=" margin-right: 80px; "> 过滤掉无效骑行 <el-switch v-model="switchFilter"></el-switch> </div>


      <div>
        <!-- 提交按钮 -->
        <el-button type="primary" @click="getEngagement">查看数据表现</el-button>
      </div>
      <div style=" margin-right: 80px; "> </div>

    </div>


    <div id="echart" style="height: 0;width: 90%; display: none;    margin: auto; "> </div>

    <el-table :data="tableData" stripe style="width: 100%" height="950"
      :default-sort="{ prop: 'title', order: 'descending' }">

      <el-table-column prop="percentage" label="percentage" width="180" sortable> </el-table-column>


      <el-table-column prop="duration" label="duration/Min"></el-table-column>


      <el-table-column prop="distance" label="distance"> </el-table-column>

      <el-table-column prop="calorie" label="calorie"> </el-table-column>


    </el-table>


  </div>
</template>

<script>



export default {
  data() {
    return {
      tableData: [],
      courseKind: 'justRide',
      radioType: 'all',
      switchFilter: true,
      range: '',
      pickerOptions: {
        shortcuts: [{
          text: '本月',
          onClick(picker) {
            picker.$emit('pick', [new Date(), new Date()]);
          }
        }, {
          text: '今年至今',
          onClick(picker) {
            const end = new Date();
            const start = new Date(new Date().getFullYear(), 0);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近六个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setMonth(start.getMonth() - 6);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    }
  },
  // 在 Vue 实例或组件中定义过滤器


  watch: {
    //watch  观察变化
    $route(newVal, oldVal) {
    },
  },
  created: function () {
    //注意回调函数的作用域!!!
  },
  mounted() {
    this.pickerOptions.shortcuts[0].onClick({
      $emit: (event, payload) => {
        if (event === 'pick') {
          this.range = payload;
        }
      }
    });
  },





  methods: {
    async getEngagement() {  //getEngagement

      this.tableData = []
      const formattedRange = this.formatRange(this.range);
      let res = await this.$http.get("/da/get_engagement/" + this.courseKind + "/" + this.radioType + "/" + this.switchFilter + "/" + formattedRange)
      this.tableData = res.data
      // console.log(res.data)
      //渲染图表
      this.getLoadEcharts();
    },
    formatRange(range) {
      if (!range || range.length !== 2) {
        return ''; // 确保range是有效的
      }
      const [start, end] = range;
      const startDate = this.formatDate(start);
      const endDate = this.formatDate(end);
      return `${startDate}-${endDate}`;
    },
    formatDate(date) {
      if (!date) return '';
      const month = date.getMonth() + 1; // 月份是从0开始的，所以加1
      const year = date.getFullYear();
      // 将月份转换为两位数格式
      const paddedMonth = month < 10 ? `0${month}` : month;
      return `${year}年${paddedMonth}月`;
    },

    getLoadEcharts() {


      var chart = this.$echarts.init(
        document.getElementById("echart")
      );


      document.getElementById('echart').style.height = '500px';
      document.getElementById('echart').style.display = 'block';
      // 重新渲染ECharts图表适应新的高度
      chart.resize();
      //进行数据预处理

      // 创建 dataChart 数组
      const dataChart = this.tableData.map(item => ({
        percentage: item.percentage,
        duration: item.duration,
        calorie: item.calorie,
        distance: item.distance,
      }));

      // if (dataChart.length > 50) {
      //   dataChart = dataChart.slice(dataChart.length - 50);
      //       }
      console.log("data  option\n", dataChart);



      // 创建图表的配置项
      const options = {
        title: {
          text: '用户数据分布' // 添加标题
        },
        // 配置项的其他设置...
        xAxis: {
          // 设置横坐标轴的数据
          data: dataChart.map(item => item.percentage)
        },
        yAxis: {
          // 配置纵坐标轴的设置...
          // 配置纵坐标轴的设置...

        },
        tooltip: {
          // 触发类型，默认数据项图形触发
          trigger: 'item',
          // 内容格式器，{a}、{b}、{c}分别代表系列名，数据项名称，数据值
          formatter: '{a} <br/>{b} : {c}'
        },
        legend: {
          // 添加图例
          data: ['duration/Min', 'distance', 'calorie']
        },
        series: [
          {
            name: 'duration/Min',
            type: 'line',
            stack: '时长',
            data: dataChart.map(item => item.duration)
          },
          {
            name: 'distance',
            type: 'line',
            stack: '骑行距离',
            data: dataChart.map(item => item.distance)
          },
          {
            name: 'calorie',
            type: 'line',
            stack: 'Calorie',
            data: dataChart.map(item => item.calorie)
          },
        ]
      };
      // 使用配置项显示图表
      chart.setOption(options);

    },


    formatDecimal(value) {
      return parseFloat(value).toFixed(2);
    },
  },







}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  display: flex;
  justify-content: flex-end;
}
</style>